import { render, staticRenderFns } from "./resourceDetailInventory.vue?vue&type=template&id=5ea46de5&scoped=true"
import script from "./resourceDetailInventory.vue?vue&type=script&lang=js"
export * from "./resourceDetailInventory.vue?vue&type=script&lang=js"
import style0 from "./resourceDetailInventory.vue?vue&type=style&index=0&id=5ea46de5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea46de5",
  null
  
)

export default component.exports